import mixpanel from 'mixpanel-browser';

mixpanel.init('08d92d4c069cfb1f6a57547619e34eff', { debug: true, track_pageview: true, persistence: 'localStorage' });

export let Mixpanel = mixpanel;